var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUCubeLocateCardBackground({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 168,
    viewBox: "0 0 187 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.983 136.513L131.949 135.513C131.949 135.513 143.568 106.863 136.008 86.0701L181.225 85.1064C183.33 90.8821 184.682 96.9052 185.246 103.027C186.21 112.83 185.45 125.172 178.983 136.513Z",
    stroke: "#F43D4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.546 101.494H177.197",
    stroke: "#F3F7FD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.097 118.612H175.747",
    stroke: "#F3F7FD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.709 109.808L176.041 110.271",
    stroke: "#F3F7FD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1275 54.9414H43.3196C43.3196 54.9414 41.0058 87.6913 54.1057 98.8688L7.30315 100.026C7.30315 100.026 -1.95184 84.612 1.1275 54.9414Z",
    stroke: "#F3F7FD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64587 68.5732H25.5567",
    stroke: "#F3F7FD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0234 78.4688H30.5451",
    stroke: "#F3F7FD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7845 86.7726C12.1248 86.4324 37.4911 86.1602 37.4911 86.1602",
    stroke: "#F3F7FD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8333 0.993164H109.862C109.862 0.993164 106.787 38.1328 118.554 51.3603H72.3617C63.9017 35.9986 61.5694 18.0041 65.8333 0.993164Z",
    fill: "#7FA7F6",
    stroke: "#5588F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6216 26.8203H101.014",
    stroke: "#5588F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8794 36.5352H91.5872",
    stroke: "#5588F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6216 13.5352L98.2431 14.6169",
    stroke: "#5588F7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M183.893 1L154.669 21.934L179.038 36.7181L183.893 1Z",
    fill: "#FFE641",
    stroke: "#FFE641",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4957 166.596L109.285 138.996L97.9203 72.4302L151.497 57.0087L177.47 13.9824",
    stroke: "#FFE641",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUCubeLocateCardBackground);
export default __webpack_public_path__ + "static/media/UCubeLocateCardBackground.99b527e85ef7bb018d439b3a9bf79043.svg";
export { ForwardRef as ReactComponent };